import { AreaChartOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import routes from '@routes';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import apiConfig from './apiConfig';

// Nguồn: ra-log-monitor-cms/source/src/constants/menuConfig.js — CHỈ 2 nhóm đang BẬT.
// Nhãn hiển thị = giá trị i18n vi.js -> navSider:
//   'Account Management' -> Quản lý tài khoản  |  'Admin' -> Quản trị viên
//   'Dữ liệu' và 'Quản lí đơn hàng' không có trong từ điển navSider nên t() trả lại chính chuỗi đó.
//
// Các nhóm bị comment ở nguồn (System/Role, Device Management, Category, News) KHÔNG đưa vào.
// Mục nào chưa port xong thì tự bị lọc bỏ (không có route) — xem MIGRATION.md.

export const navMenuConfig = [
    {
        label: <FormattedMessage defaultMessage="Quản lý tài khoản" />,
        key: 'account-management',
        icon: <UsergroupAddOutlined />,
        children: [
            {
                label: <FormattedMessage defaultMessage="Quản trị viên" />,
                key: 'admin',
                path: routes.adminListPage?.path,
                permission: [apiConfig.user.getList.permissionCode],
            },
        ],
    },
    {
        label: <FormattedMessage defaultMessage="Dữ liệu" />,
        key: 'data',
        icon: <AreaChartOutlined />,
        children: [
            {
                label: <FormattedMessage defaultMessage="Quản lí đơn hàng" />,
                key: 'log-management',
                path: routes.logManagementListPage?.path,
                permission: [apiConfig.logs.getList.permissionCode],
            },
        ],
    },
]
    .map((group) => ({ ...group, children: group.children.filter((item) => !!item.path) }))
    .filter((group) => group.children.length > 0);

// Làm phẳng menu (nguồn: menuConfig)
const flatNav = (menus) =>
    menus.reduce((rs, menu) => (menu.children ? [...rs, ...flatNav(menu.children)] : [...rs, menu]), []);

export const flatNavMenuConfig = flatNav(navMenuConfig);
